/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface PersonNameInfo
 */
export interface PersonNameInfoOptional {
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  organization?: string;
}

export interface PersonNameInfo extends PersonNameInfoOptional {
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  organization?: string;
}

export interface PersonNameInfoTrackedI {
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  prefix?: string;
  prefixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  first?: string;
  firstIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  middle?: string;
  middleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  last?: string;
  lastIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  suffix?: string;
  suffixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  preferred?: string;
  preferredIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonNameInfo
   */
  organization?: string;
  organizationIsSet: boolean;
}

transformDatesMap.set("PersonNameInfo", function (model: PersonNameInfo) {});

export type PersonNameInfoMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  prefix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  first: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  middle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  last: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  suffix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  preferred: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  organization: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PersonNameInfoMeta: PersonNameInfoMetaI = {} as PersonNameInfoMetaI;
PersonNameInfoMeta = typeMeta("PersonNameInfo", {
  prefix: propertyMeta("prefix", false, false, false, MetaTypesBase.string),
  first: propertyMeta("first", false, false, false, MetaTypesBase.string),
  middle: propertyMeta("middle", false, false, false, MetaTypesBase.string),
  last: propertyMeta("last", false, false, false, MetaTypesBase.string),
  suffix: propertyMeta("suffix", false, false, false, MetaTypesBase.string),
  preferred: propertyMeta(
    "preferred",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  organization: propertyMeta(
    "organization",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PersonNameInfoMeta;

registerMeta(() => {});

export class PersonNameInfoTracked implements PersonNameInfoTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  prefix__I?: string = undefined;
  prefixIsSet: boolean = false;
  set prefix(v: undefined | string) {
    if (v !== undefined) {
      this.prefix__I = v;
      this.prefixIsSet = true;
    } else {
      this.prefix__I = v || undefined;
      this.prefixIsSet = false;
    }
    this.changeTracker = true;
  }
  get prefix() {
    return this.prefix__I;
  }
  first__I?: string = undefined;
  firstIsSet: boolean = false;
  set first(v: undefined | string) {
    if (v !== undefined) {
      this.first__I = v;
      this.firstIsSet = true;
    } else {
      this.first__I = v || undefined;
      this.firstIsSet = false;
    }
    this.changeTracker = true;
  }
  get first() {
    return this.first__I;
  }
  middle__I?: string = undefined;
  middleIsSet: boolean = false;
  set middle(v: undefined | string) {
    if (v !== undefined) {
      this.middle__I = v;
      this.middleIsSet = true;
    } else {
      this.middle__I = v || undefined;
      this.middleIsSet = false;
    }
    this.changeTracker = true;
  }
  get middle() {
    return this.middle__I;
  }
  last__I?: string = undefined;
  lastIsSet: boolean = false;
  set last(v: undefined | string) {
    if (v !== undefined) {
      this.last__I = v;
      this.lastIsSet = true;
    } else {
      this.last__I = v || undefined;
      this.lastIsSet = false;
    }
    this.changeTracker = true;
  }
  get last() {
    return this.last__I;
  }
  suffix__I?: string = undefined;
  suffixIsSet: boolean = false;
  set suffix(v: undefined | string) {
    if (v !== undefined) {
      this.suffix__I = v;
      this.suffixIsSet = true;
    } else {
      this.suffix__I = v || undefined;
      this.suffixIsSet = false;
    }
    this.changeTracker = true;
  }
  get suffix() {
    return this.suffix__I;
  }
  preferred__I?: string = undefined;
  preferredIsSet: boolean = false;
  set preferred(v: undefined | string) {
    if (v !== undefined) {
      this.preferred__I = v;
      this.preferredIsSet = true;
    } else {
      this.preferred__I = v || undefined;
      this.preferredIsSet = false;
    }
    this.changeTracker = true;
  }
  get preferred() {
    return this.preferred__I;
  }
  organization__I?: string = undefined;
  organizationIsSet: boolean = false;
  set organization(v: undefined | string) {
    if (v !== undefined) {
      this.organization__I = v;
      this.organizationIsSet = true;
    } else {
      this.organization__I = v || undefined;
      this.organizationIsSet = false;
    }
    this.changeTracker = true;
  }
  get organization() {
    return this.organization__I;
  }
  constructor(config?: PersonNameInfoOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PersonNameInfoOptional,
    options?: AssignOptions,
  ): PersonNameInfoTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.prefix && this.prefixApplyFilter(optionsRequired.filter)) {
      this.prefix = config.prefix;
      if (optionsRequired.unassign) this.prefixIsSet = false;
      else this.prefixIsSet = true;
    }
    if (config.first && this.firstApplyFilter(optionsRequired.filter)) {
      this.first = config.first;
      if (optionsRequired.unassign) this.firstIsSet = false;
      else this.firstIsSet = true;
    }
    if (config.middle && this.middleApplyFilter(optionsRequired.filter)) {
      this.middle = config.middle;
      if (optionsRequired.unassign) this.middleIsSet = false;
      else this.middleIsSet = true;
    }
    if (config.last && this.lastApplyFilter(optionsRequired.filter)) {
      this.last = config.last;
      if (optionsRequired.unassign) this.lastIsSet = false;
      else this.lastIsSet = true;
    }
    if (config.suffix && this.suffixApplyFilter(optionsRequired.filter)) {
      this.suffix = config.suffix;
      if (optionsRequired.unassign) this.suffixIsSet = false;
      else this.suffixIsSet = true;
    }
    if (config.preferred && this.preferredApplyFilter(optionsRequired.filter)) {
      this.preferred = config.preferred;
      if (optionsRequired.unassign) this.preferredIsSet = false;
      else this.preferredIsSet = true;
    }
    if (
      config.organization &&
      this.organizationApplyFilter(optionsRequired.filter)
    ) {
      this.organization = config.organization;
      if (optionsRequired.unassign) this.organizationIsSet = false;
      else this.organizationIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonNameInfoTrackedI {
    const cloned = {} as PersonNameInfoTrackedI;
    if (
      this.prefixIsSetDeep() &&
      this.prefixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prefixIsSet = true;
      cloned.prefix = this.prefix;
    } else {
      //cloned.prefixIsSet = false
    }
    if (
      this.firstIsSetDeep() &&
      this.firstApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.firstIsSet = true;
      cloned.first = this.first;
    } else {
      //cloned.firstIsSet = false
    }
    if (
      this.middleIsSetDeep() &&
      this.middleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.middleIsSet = true;
      cloned.middle = this.middle;
    } else {
      //cloned.middleIsSet = false
    }
    if (
      this.lastIsSetDeep() &&
      this.lastApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lastIsSet = true;
      cloned.last = this.last;
    } else {
      //cloned.lastIsSet = false
    }
    if (
      this.suffixIsSetDeep() &&
      this.suffixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.suffixIsSet = true;
      cloned.suffix = this.suffix;
    } else {
      //cloned.suffixIsSet = false
    }
    if (
      this.preferredIsSetDeep() &&
      this.preferredApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.preferredIsSet = true;
      cloned.preferred = this.preferred;
    } else {
      //cloned.preferredIsSet = false
    }
    if (
      this.organizationIsSetDeep() &&
      this.organizationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.organizationIsSet = true;
      cloned.organization = this.organization;
    } else {
      //cloned.organizationIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonNameInfoTrackedI {
    if (!this.prefixApplyFilter(filter)) this.prefixIsSet = false;

    if (!this.firstApplyFilter(filter)) this.firstIsSet = false;

    if (!this.middleApplyFilter(filter)) this.middleIsSet = false;

    if (!this.lastApplyFilter(filter)) this.lastIsSet = false;

    if (!this.suffixApplyFilter(filter)) this.suffixIsSet = false;

    if (!this.preferredApplyFilter(filter)) this.preferredIsSet = false;

    if (!this.organizationApplyFilter(filter)) this.organizationIsSet = false;

    return this;
  }
  prefixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoMeta.prefix,
      PersonNameInfoMeta,
      this.prefix,
      this,
    );
  }
  prefixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.prefixIsSet && this.prefixApplyFilter(filter)) return true;

    return false;
  }
  firstApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoMeta.first,
      PersonNameInfoMeta,
      this.first,
      this,
    );
  }
  firstIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.firstIsSet && this.firstApplyFilter(filter)) return true;

    return false;
  }
  middleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoMeta.middle,
      PersonNameInfoMeta,
      this.middle,
      this,
    );
  }
  middleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.middleIsSet && this.middleApplyFilter(filter)) return true;

    return false;
  }
  lastApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PersonNameInfoMeta.last, PersonNameInfoMeta, this.last, this);
  }
  lastIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lastIsSet && this.lastApplyFilter(filter)) return true;

    return false;
  }
  suffixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoMeta.suffix,
      PersonNameInfoMeta,
      this.suffix,
      this,
    );
  }
  suffixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.suffixIsSet && this.suffixApplyFilter(filter)) return true;

    return false;
  }
  preferredApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoMeta.preferred,
      PersonNameInfoMeta,
      this.preferred,
      this,
    );
  }
  preferredIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.preferredIsSet && this.preferredApplyFilter(filter)) return true;

    return false;
  }
  organizationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonNameInfoMeta.organization,
      PersonNameInfoMeta,
      this.organization,
      this,
    );
  }
  organizationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.organizationIsSet && this.organizationApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.prefixIsSetDeep(filter)) return true;
    if (this.firstIsSetDeep(filter)) return true;
    if (this.middleIsSetDeep(filter)) return true;
    if (this.lastIsSetDeep(filter)) return true;
    if (this.suffixIsSetDeep(filter)) return true;
    if (this.preferredIsSetDeep(filter)) return true;
    if (this.organizationIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
